export default __webpack_public_path__ + "static/media/app-poster-hard-launch.b1017686.jpg";